import _ from 'lodash'
import WidgetConfigMenu from '../widget-config-menu'
import ConfigWidgetLabel from 'scoreboard/dashboards/widgets/config-widget-label'
import appDisplay from 'scoreboard/components/app-display'
import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import i18n from 'scoreboard/components/i18n'
import ConfigTimelineRange from './config-timeline-range'
import configBackground from '../wob-background-menu'
import ObjectSelectorForm from 'scoreboard/components/object-selector-form'
import createInitDataSourceOption from '../create-init-data-source-option'

const InitiativeTimelineWidgetConfig = WidgetConfigMenu.extend({

	width: 180,

	typeSpecificTargets() {
		let targets = []
		targets.push(this.setTitle())
		// #58045 - include allowAll in the options so that the "All Initiatives"
		// item will be displayed in the initiatives gardener
		targets.push(createInitDataSourceOption(this.model, {allowAll: true}))
		targets.push(configBackground(this.model.properties))
		targets.push(createInitialExpansionMenu(this.model))
		targets.push(this.dateRange())
		targets.push(this.toggle(
			'initiatives.timeline.showLeftPane', 'showLeftPane'))
		targets.push(this.toggle(
			'initiatives.timeline.showFooter', 'showFooter'))
		return targets
	},

	setTitle() {
		return {
			type: 'dialog',
			label: 'dashboards.setTitle',
			target: function (e) {
				let configView = new ConfigTimelineLabel({
					model: this.model
				})

				appDisplay.dialog(configView)

				e.preventDefault()
				this.trigger('done')
			}.bind(this)
		}
	},

	dateRange() {
		return {
			type: 'dialog',
			label: 'report.date.range',
			target: function (e) {
				let configView = new ConfigTimelineRange({
					model: this.model
				})

				appDisplay.dialog(configView)

				e.preventDefault()
				this.trigger('done')
			}.bind(this)
		}
	},

	toggle(label, prop) {
		return {
			type: 'toggle',
			label: i18n.get(label),
			contentView: BootslideMenu.WidgetToggleProperty.extend({
				property: {
					name: prop,
					label: i18n.get(label)
				}
			}),
			model: this.model.properties
		}
	}

})

const ConfigTimelineLabel = ConfigWidgetLabel.extend({
	dialogTitle: 'dashboards.setTitle',

	_getModelLabel: function () {
		return this.model.properties.get('label')
	},

	_setModelLabel: function (label) {
		this.model.properties.set('label', label)
	},

	_getSuggestion: function () {
		let props = this.model.properties

		let initiativeId = props.get('initiativeId')
		if (initiativeId) {
			return this.model.data._data.initiativeTrees[initiativeId][0].label
		} else {
			let orgId = props.get('organizationId')
			if (orgId) {
				return this.model.data.organizations(orgId).label
			}
		}
	}
})

const InitialExpansionOption = BootslideMenu.WidgetMultipleChoiceOption.extend({
	property: 'initialExpansion'
})

function createInitialExpansionMenu (widgetModel) {
	var options = _.map(['collapseAll', 'expandOneLevel', 'expandAll'], function (type) {
		return {
			label: type,
			contentView: InitialExpansionOption.extend({
				value: type,
				label: i18n.get('common.tree.' + type)
			}),
			model: widgetModel.properties
		}
	})

	return {
		id: 'initialExpansion',
		type: 'submenu',
		label: 'initiatives.timeline.showExpanded',
		width: 200,
		target: options
	}
}

export default InitiativeTimelineWidgetConfig

InitiativeTimelineWidgetConfig.__filename__ = 'dashboards/widgets/initiative-timeline/initiative-timeline-widget-config.js'
